module.exports = __webpack_public_path__ + "img/icon-pedidos-entrega.454b867b.svg";